import { render, staticRenderFns } from "./order-date-label.vue?vue&type=template&id=33638038&"
import script from "./order-date-label.vue?vue&type=script&lang=js&"
export * from "./order-date-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports